/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartfallbackfailed4Inputs */

const en_eventaistartfallbackfailed4 = /** @type {(inputs: Eventaistartfallbackfailed4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify could not fill in the event right now. We kept what you typed, please fill in the rest yourself.`)
};

const de_eventaistartfallbackfailed4 = /** @type {(inputs: Eventaistartfallbackfailed4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify konnte das Event gerade nicht ausfüllen. Was du eingegeben hast, ist übernommen, bitte füll den Rest selbst aus.`)
};

/**
* | output |
* | --- |
* | "Pulsify could not fill in the event right now. We kept what you typed, please fill in the rest yourself." |
*
* @param {Eventaistartfallbackfailed4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartfallbackfailed4 = /** @type {((inputs?: Eventaistartfallbackfailed4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartfallbackfailed4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartfallbackfailed4(inputs)
	return de_eventaistartfallbackfailed4(inputs)
});
export { eventaistartfallbackfailed4 as "eventAiStartFallbackFailed" }